import { NgClass } from '@angular/common';
import { Component, EventEmitter, Output, input } from '@angular/core';

import { MessageType } from '../../../model/message.model';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'show-message',
    templateUrl: 'message-component.html',
    imports: [NgClass],
})
export class MessageComponent {
    readonly type = input<MessageType>();
    readonly showHeader = input<boolean>(false);
    readonly showClose = input<boolean>(false);
    readonly showIcon = input<boolean>(true);
    readonly showLink = input<boolean>(false);
    readonly messageText = input<string>('');
    readonly p1Class = input<string>('');
    readonly id = input('default-message');
    @Output() readonly close: any = new EventEmitter();

    public get messageType(): typeof MessageType {
        return MessageType;
    }
    closeMessage() {
        this.close.emit(true);
    }
}
